import React from 'react';
import { Skeleton } from 'antd';
import { FormattedMessage } from 'react-intl';
import { getCleanedHighlights } from '../../Utils/KeywordHighlightUtil';
import HtmlViewer from '../HtmlViewer/HtmlViewer';
import PdfViewer from '../PdfViewer/PdfViewer';
import TextViewer from '../TextViewer/TextViewer';
import ResumeIcon from '../../Icons/ResumeIcon';
import ResumePreviewNotAvailableIcon from '../../Icons/ResumePreviewNotAvailableIcon';
import styles from './ResumeViewer.module.scss';
import candidateDrawerMessage from '../../Containers/CandidateDrawer/messages';

const emptyArray = [];

function ResumeViewer(props) {
  const {
    resume,
    highlights,
    mustHavesKeywords = emptyArray,
    candidateDetailsStatus,
    candidateListStatus,
    isSocialResumeDownloadAllowed,
    isSocialResumeGenerationEnabled,
    resumeDownloadButton,
    isUserProhibitedFromPerformingActions,
  } = props;

  const cleanedHighlights = getCleanedHighlights(highlights);

  const resumeViewer = resumeDetails => {
    switch (resumeDetails.MediaType) {
      case 'application/pdf':
        return (
          <PdfViewer
            highlights={cleanedHighlights}
            mustHavesKeywords={mustHavesKeywords}
            base64PdfContent={`data:application/pdf;base64,${resumeDetails.Content}`}
          />
        );
      case 'text/html':
        return (
          <HtmlViewer
            mustHavesKeywords={mustHavesKeywords}
            highlights={cleanedHighlights}
            htmlContent={resumeDetails.Content}
          />
        );
      case 'text/plain':
        return (
          <TextViewer
            mustHavesKeywords={mustHavesKeywords}
            highlights={cleanedHighlights}
            className="resume-textviewer"
            text={resumeDetails.Content}
          />
        );
      default:
        return (
          <div style={{ height: 'inherit' }}>
            <ResumePreviewNotAvailableIcon className={styles.resumeIcon} />
            <span className={styles.resumeInfoText}>
              {' '}
              <FormattedMessage {...candidateDrawerMessage.resumePreviewNotAvailableMessage} />
            </span>
            <div className={styles.resumeDownloadButton}>{resumeDownloadButton}</div>
          </div>
        );
    }
  };

  const getResumeInfoText = () => {
    if (isSocialResumeDownloadAllowed)
      return (
        <div
          style={{
            height: 'inherit',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ResumeIcon className={styles.resumeIcon} />
          <span className={styles.resumeInfoText}>
            {' '}
            <FormattedMessage {...candidateDrawerMessage.downloadGeneratedResumeMessage} />
          </span>
          <div className={styles.resumeDownloadButton}>{resumeDownloadButton}</div>
        </div>
      );
    if (isSocialResumeGenerationEnabled)
      return (
        <div style={{ height: 'inherit' }}>
          <ResumeIcon className={styles.resumeIcon} />
          <span className={styles.resumeInfoText}>
            {' '}
            <FormattedMessage {...candidateDrawerMessage.pullContactsForResumeMessage} />
          </span>
        </div>
      );
    return (
      <div style={{ height: 'inherit' }}>
        <ResumeIcon className={styles.resumeIcon} />
        <span className={styles.resumeInfoText}>
          {' '}
          <FormattedMessage {...candidateDrawerMessage.resumeNotAvailableMessage} />
        </span>
      </div>
    );
  };

  const resumeInfoText = getResumeInfoText();

  return (
    <Skeleton
      paragraph={{ rows: 10 }}
      loading={candidateDetailsStatus === 'INPROGRESS' || candidateListStatus === 'INPROGRESS'}
    >
      {resume && !isUserProhibitedFromPerformingActions ? resumeViewer(resume) : resumeInfoText}
    </Skeleton>
  );
}

export default ResumeViewer;
